document.addEventListener("DOMContentLoaded", () => {
  const activeLink = document.querySelector('.nav-cta[aria-current="page"]');
  if (activeLink) {
    activeLink.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
  }
});

class FormEnhancer {
  constructor(formContainerSelector = ".shopify-app-block") {
    this.formContainer = document.querySelector(formContainerSelector);
    if (!this.formContainer) {
      console.warn("Form container not found");
      return;
    }
    this.formEmbed = null;
    this.shadow = null;
    this.form = null;
    this.uploadLabelContainer = null;
    this.clearButton = null;
    this.observer = null;
    this.labelObserver = null;
    this.fieldObserver = null;
    this.checkboxObserver = null;
    this.uploadObserver = null;
    this.isUpdatingText = false; 
    this.debounceTimeout = null; 
    this.initialize();
  }


  initialize() {
    this.setupMainObserver();
  }


  addLabelClass(label) {
    if (label && !label.classList.contains("field__label")) {
      label.classList.add("field__label");
    }
  }


  setupMainObserver() {
    this.observer = new MutationObserver(() => {
      console.debug("Main observer triggered");
      this.formEmbed = document.querySelector("shopify-forms-embed");
      this.shadow = this.formEmbed?.shadowRoot;
      this.form = this.shadow?.querySelector("form");
      this.uploadLabelContainer = this.form?.querySelector("button#custom\\#upload_file-label") || this.form?.querySelector("button#custom\\#attach_files-label");
      this.clearButton = this.form?.querySelector("#custom\\#upload_file-clear");

      if (!this.formEmbed || !this.shadow || !this.form) {
        console.warn("Form embed or shadow DOM not found");
        return;
      }
      
      this.observer.disconnect();
      this.enhanceForm();
    });

    this.observer.observe(this.formContainer, { childList: true, subtree: true });
  }


  enhanceForm() {
    this.loadStylesheet();
    this.applyBaseFormStyles();
    this.setupLabelObserver();
    this.setupFieldObserver();
    this.removeCountryButton();
    this.reStructureCountryButton();
    this.handleFormTypeLogic();
    this.enhanceCheckboxes();
    this.setupCheckboxObserver();
    this.setupUploadButton();
    this.setupSubmitButtonObserver();
    this.addCustomClassOnPhoneFieldContainer();
    this.detectAndAddDeviceClass();
    this.formContainer.classList.add("loaded");
  }


  loadStylesheet() {
    this.shadow.adoptedStyleSheets = [];
    this.shadow.querySelector("style")?.remove();
    const stylesheetUrl = window.shopifyFormsAssets?.formStyles;
    if (!stylesheetUrl) {
      console.warn("Stylesheet url not defined");
      return;
    }
    const linkEl = document.createElement("link");
    linkEl.setAttribute("rel", "stylesheet");
    linkEl.setAttribute("href", stylesheetUrl);
    linkEl.setAttribute("type", "text/css");
    this.shadow.appendChild(linkEl);
  }


  applyBaseFormStyles() {
    this.form.classList.add("custom-form");
    this.form.removeAttribute("novalidate");
    this.form.querySelectorAll("label").forEach((label) => this.addLabelClass(label));
  }


  setupLabelObserver() {
    this.labelObserver = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE && node.tagName === "LABEL") {
            this.addLabelClass(node);
          }
        });
        if (
          mutation.type === "attributes" &&
          mutation.target.tagName === "LABEL" &&
          !mutation.target.classList.contains("field__label")
        ) {
          this.addLabelClass(mutation.target);
        }
      }
    });

    this.labelObserver.observe(this.form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }


  enforceFieldStructure() {
    const formDivs = this.form.querySelectorAll(":scope > div");
    formDivs.forEach((div) => {
      if (div.classList.contains("contact__fields")) {
        div.querySelectorAll(":scope > div").forEach((childDiv) => {
          childDiv.classList.add("field", "field--input");
          this.addLabelClass(childDiv.querySelector("label"));
        });
      } else {
        div.classList.add("field", "field--input");
        this.addLabelClass(div.querySelector("label"));
      }
    });
  }


  applyTextareaAndPlaceholderRules() {
      this.form.querySelectorAll("textarea").forEach((textarea) => {
        textarea.setAttribute("rows", "9");

        if (!textarea.hasAttribute("placeholder")) {
          textarea.setAttribute("placeholder", "Enter your message here");
        }
        
        textarea.setAttribute("aria-label", "Message input");
        
        const label = textarea.closest(".field--input")?.querySelector("label");
        if (label) {
          const labelText = label.textContent.trim();
          label.classList.remove("short-text-field-label", "large-text-field-label");
          this.form.classList.remove("short-textarea-form", "large-textarea-form");
          if (labelText.length <= 50) {
            label.classList.add("short-text-field-label");
            this.form.classList.add("short-textarea-form");
          } else {
            label.classList.add("large-text-field-label");
            this.form.classList.add("large-textarea-form");
          }
        }
      });
      this.form
        .querySelectorAll(".field--input input:not([type='checkbox'])")
        .forEach((input) => {
          if (!input.hasAttribute("placeholder")) {
            input.setAttribute("placeholder", "");
          }
        });
  }


  setupFieldObserver() {
    this.fieldObserver = new MutationObserver(() => {
      this.enforceFieldStructure();
      this.applyTextareaAndPlaceholderRules();
    });
    this.fieldObserver.observe(this.form, { childList: true, subtree: true });
    this.enforceFieldStructure();
    this.applyTextareaAndPlaceholderRules();
  }


  removeCountryButton() {
    const divs = this.form.querySelectorAll(":scope > div");
  
    divs.forEach((div) => {
      const countryBtn = div.querySelector('button[aria-controls="country-selector-dropdown"]')?.closest("div");
  
      if (countryBtn) {
        if (countryBtn.nextElementSibling) {
          console.log(countryBtn.nextElementSibling);
          countryBtn.nextElementSibling.appendChild(countryBtn);
          countryBtn.classList.add("country-selector-container");
          countryBtn.querySelector("button span:nth-of-type(2)").remove();
        }
        // countryBtn.remove();
      }
    });
  }

  reStructureCountryButton() {
    const divs = this.form.querySelectorAll(":scope > div");
  
    divs.forEach((div) => {
      const countryBtnWrapper = div.querySelector('button[aria-controls="country-selector-dropdown"]')?.closest("div");
  
      if (countryBtnWrapper) {
        countryBtnWrapper.classList.add("country-selector-container");
  
        const secondSpan = countryBtnWrapper.querySelector("button span:nth-of-type(2)");
        if (secondSpan) {
          secondSpan.remove();
        }
  
        if (countryBtnWrapper.nextElementSibling) {
          countryBtnWrapper.nextElementSibling.appendChild(countryBtnWrapper);
        }
      }
    });
  }

  moveOutputBelowInput(inputId, keyword) {
    const input = this.form.querySelector(`input#${inputId}`);
    if (!input) {
      console.warn(`Input with id ${inputId} not found`);
      return;
    }
    const outputObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (
              node.tagName === "OUTPUT" &&
              (node.textContent.includes(keyword) ||
                node.textContent.includes(`${keyword} is required`)) &&
              node.parentNode !== input.parentNode
            ) {
              input.parentNode.insertBefore(node, input.nextSibling);
            }
          });
        }
      }
    });
    outputObserver.observe(this.form, { childList: true, subtree: true });
  }

  moveOutputBelowInputBySelector(inputSelector, keyword) {
    const input = this.form.querySelector(`input${inputSelector}`);
    if (!input) {
      console.warn(`Input with selector ${inputSelector} not found`);
      return;
    }

    const outputObserver = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === "childList") {
          mutation.addedNodes.forEach((node) => {
            if (
              node.tagName === "OUTPUT" &&
              (node.textContent.includes(keyword) ||
                node.textContent.includes(`${keyword} is required`)) &&
              node.parentNode !== input.parentNode
            ) {
              input.parentNode.insertBefore(node, input.nextSibling);
            }
          });
        }
      }
    });

    outputObserver.observe(this.form, { childList: true, subtree: true });
  }


  wrapFields(inputIds = []) {
    const inputDivs = inputIds
      .map((id) => this.form.querySelector(`input#${id}`)?.closest("div"))
      .filter(Boolean);
    if (inputDivs.length === inputIds.length) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("contact__fields", "contact-form-grid-fields");
      inputDivs[0].parentNode.insertBefore(wrapper, inputDivs[0]);
      inputDivs.forEach((div) => wrapper.appendChild(div));
    }
  }


  // wrapFieldsByIds(inputSelectors = []) {
  //   const inputDivs = inputSelectors
  //     .map((selector) => this.form.querySelector(`input${selector}`)?.closest("div"))
  //     .filter(Boolean);
  //   if (inputDivs.length === inputSelectors.length) {
  //     const wrapper = document.createElement("div");
  //     wrapper.classList.add("contact__fields", "contact-form-grid-fields");
  //     inputDivs[0].parentNode.insertBefore(wrapper, inputDivs[0]);
  //     inputDivs.forEach((div) => wrapper.appendChild(div));
  //   }
  // }
  wrapFieldsByIds(inputIds = []) {
    const inputDivs = inputIds
      .map((id) => {
        const input = this.form.querySelector(`input#${CSS.escape(id)}`);
        return input?.closest("div");
      })
      .filter(Boolean);

    if (inputDivs.length === inputIds.length) {
      const wrapper = document.createElement("div");
      wrapper.classList.add("contact__fields", "contact-form-grid-fields");
      inputDivs[0].parentNode.insertBefore(wrapper, inputDivs[0]);
      inputDivs.forEach((div) => wrapper.appendChild(div));
    }
  }


  handleFormTypeLogic() {
    const dynamicFormType = this.shadow?.querySelector("h2")?.textContent?.trim();
    if (dynamicFormType) {
      this.shadow.querySelector("h2").classList.add("hide-form-title");
      if (
        dynamicFormType === "Ambassador Form" ||
        dynamicFormType === "Shipping and Returns" ||
        dynamicFormType === "wholesale"
      ) {
        this.wrapFields(["first_name", "last_name"]);
        this.wrapFieldsByIds(["#custom\\#state", "#custom\\#zip_code"]);
        this.moveOutputBelowInput("first_name", "First name");
        this.moveOutputBelowInput("last_name", "Last name");
      }
      if (dynamicFormType === "contact form") {
        this.wrapFields(["first_name", "email"]);
        this.moveOutputBelowInput("first_name", "First name");
        this.moveOutputBelowInput("email", "Email");
        this.moveOutputBelowInput("email", `${window.shopifyFormsAssets.formValidationErrorMessage}`);
      }
    } else {
      console.warn("Form title <h2> not found");
    }
  }


  enhanceCheckboxes() {
    const checkboxes = this.form.querySelectorAll('fieldset input[type="checkbox"]');
    checkboxes.forEach((checkbox) => {
      if (!checkbox.classList.contains("visually-hidden")) {
        checkbox.classList.add("visually-hidden");
      }
      const parent = checkbox.parentNode;
      if (!parent.querySelector(".custom-checkbox-icon")) {
        const span = document.createElement("span");
        span.classList.add("custom-checkbox-icon");
        span.innerHTML = `<svg viewBox="0 0 12 10" height="10px" width="12px"><polyline points="1.5 6 4.5 9 10.5 1"></polyline></svg>`;
        parent.appendChild(span);
      }
    });
  }


  setupCheckboxObserver() {
    this.checkboxObserver = new MutationObserver(() => {
      this.enhanceCheckboxes();
    });
    this.checkboxObserver.observe(this.form, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["class"],
    });
  }


  enforceUploadButtonText() {
    if (!this.uploadLabelContainer || this.isUpdatingText) return;
    this.isUpdatingText = true;
    this.uploadObserver?.disconnect();
    try {
      const currentP = this.uploadLabelContainer.querySelector("p");
      if (currentP && currentP.textContent.trim() !== "Attach files") {
        currentP.textContent = "Attach files";
      }
    } catch (error) {
      console.error("Error in enforceUploadButtonText:", error);
    } finally {
      this.uploadObserver?.observe(this.uploadLabelContainer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
      this.isUpdatingText = false;
    }
  }


  setupUploadButton() {
    if (this.uploadLabelContainer) {
      this.uploadObserver = new MutationObserver(() => {
        clearTimeout(this.debounceTimeout);
        this.debounceTimeout = setTimeout(() => {
          this.enforceUploadButtonText();
        }, 50);
      });
      this.enforceUploadButtonText();
      this.uploadObserver.observe(this.uploadLabelContainer, {
        childList: true,
        subtree: true,
        characterData: true,
      });
    }

    if (this.clearButton) {
      this.clearButton.addEventListener("click", () => {
        this.enforceUploadButtonText();
      }, { once: false });
    }
  }

  setupSubmitButtonObserver() {

    this.submitButton = this.form?.querySelector('button[type="submit"]');
    if (!this.submitButton) {
      console.warn("Submit button not found in form");
      return;
    }


    this.updateSubmitButtonClass();


    const submitObserver = new MutationObserver((mutations) => {
      // console.debug("Submit button observer triggered");
      mutations.forEach((mutation) => {
        if (mutation.attributeName === "aria-disabled") {
          this.updateSubmitButtonClass();
        }
      });
    });

    submitObserver.observe(this.submitButton, { attributes: true, attributeFilter: ["aria-disabled"] });
  }

  updateSubmitButtonClass() {
    const isDisabled = this.submitButton.getAttribute("aria-disabled") === "true";
    if (isDisabled) {
      this.submitButton.classList.add("disabled-button");
    } else {
      this.submitButton.classList.remove("disabled-button");
    }
  }

  addCustomClassOnPhoneFieldContainer() {
    if (this.form) {
      const input = this.form.querySelector('#phone_number');
      if (input) {
        const firstParentDiv = input.closest('div');
        if (firstParentDiv) {
          const ensureClass = () => {
            if (!firstParentDiv.classList.contains('phone-field-and-country-selector-wrapper')) {
              firstParentDiv.classList.add('phone-field-and-country-selector-wrapper');
            }
          };
          ensureClass();
          const config = { 
            childList: true, 
            subtree: true, 
            attributes: true, 
            characterData: true,
            attributeFilter: ['class', 'value'] 
          };
          const observer = new MutationObserver(() => {
            ensureClass();
          });
          observer.observe(this.form, config);
        }
      }
    }
  }

  detectAndAddDeviceClass() {
    let deviceClass = '';
    const ua = navigator.userAgent;
    const isIPad = /iPad/i.test(ua) || (/Macintosh/i.test(ua) && navigator.maxTouchPoints && navigator.maxTouchPoints > 2);
    if (/iPhone/i.test(ua)) {
      deviceClass = 'iphone-shopify-form';
    } else if (isIPad) {
      deviceClass = 'ipad-shopify-form';
    } else if (/Macintosh/i.test(ua)) {
      deviceClass = 'mac-shopify-form';
    } else if (/Windows/i.test(ua)) {
      deviceClass = 'windows-shopify-form';
    }
    if (deviceClass && this.form) {
      this.form.classList.add(deviceClass);
      const config = { attributes: true, attributeFilter: ['class'] };
      const observer = new MutationObserver(() => {
        if (!this.form.classList.contains(deviceClass)) {
          this.form.classList.add(deviceClass);
        }
      });
      observer.observe(this.form, config);
    }
  }
    
  destroy() {
    this.observer?.disconnect();
    this.labelObserver?.disconnect();
    this.fieldObserver?.disconnect();
    this.checkboxObserver?.disconnect();
    this.uploadObserver?.disconnect();
    clearTimeout(this.debounceTimeout);
  }
}


const formEnhancer = new FormEnhancer();